import { css as s, styled as t } from "./styled2.mjs";
import { InputLabel as l } from "./index46.mjs";
const a = s`
	color: ${({ theme: e, $disabled: o }) => o ? e.palette.text.disabled : e.deprecated.tokens.stennGrey};
	padding-bottom: ${({ theme: e }) => e.tokens.spacing[2]};
`, p = t(l)`
	${a}
`;
t("div")`
	position: relative;
	display: flex;
`;
export {
  p as OverLabel
};
//# sourceMappingURL=styles31.mjs.map
